<template>
    <md-list class="ModeratorMenue">
    
        <!-- Screensharing -->
        <md-list-item @click="toggleScreenSharing(); toggleModeratorMenue();"> 
            <MonitorShareIcon class="md-list-item-icon"/>
            <span class="md-list-item-text">{{ $t('Bildschirm teilen') }}</span>
        </md-list-item>

        <!-- Follow Moderator mode -->
        <md-list-item @click="toggleFollowModeratorMode(); toggleModeratorMenue();" :class="{'mm-list-item-active': sendingFollowModerator}"> 
            <Eye class="md-list-item-icon"/>
            <span v-if="!sendingFollowModerator" class="md-list-item-text">{{ $t('Geführter Modus aktivieren') }}</span>
            <span v-else class="md-list-item-text">{{ $t('Geführter Modus deaktivieren') }}</span>
        </md-list-item>

        <!-- Mute all -->
        <md-list-item @click="muteAll(); toggleModeratorMenue();"> 
            <VolumeOff class="md-list-item-icon"/>
            <span class="md-list-item-text">{{ $t('Alle Teilnehmer stummschalten') }}</span>
        </md-list-item>

        <!-- VideoOff all -->
        <md-list-item @click="stopVideoAll(); toggleModeratorMenue();"> 
            <VideoOff class="md-list-item-icon"/>
            <span class="md-list-item-text">{{ $t('Videos aller Teilnehmer ausstellen') }}</span>
        </md-list-item>

        <!-- Remove all -->
        <md-list-item @click="removeAll(); toggleModeratorMenue();"> 
            <AccountOff class="md-list-item-icon"/>
            <span class="md-list-item-text">{{ $t('Alle Teilnehmer Entfernen') }}</span>
        </md-list-item>

    </md-list>
</template>

<script>
import {mapGetters, mapState, mapMutations, mapActions} from "vuex";

// Icons
import MonitorShareIcon from 'vue-material-design-icons/MonitorShare.vue'
import VolumeOff from 'vue-material-design-icons/VolumeOff.vue'
import VideoOff from 'vue-material-design-icons/VideoOff.vue'
import AccountOff from 'vue-material-design-icons/AccountOff.vue'
import Eye from 'vue-material-design-icons/Eye.vue'

export default {
    components:{MonitorShareIcon,VolumeOff,VideoOff,AccountOff,Eye},
    inject: ['toggleScreenSharing','toggleModeratorMenue'],
    data: () => ({
        moderatorMenueVisible: false,
    }),
    computed:{
        ...mapGetters(['users',"localUserID","sendingFollowModerator","currentSituationID"]),
        ...mapState({
            session: (state) => state.session.openTokSession,
            openTokStreams: (state) => state.session.openTokStreams,
        }),
    },
    watch: {
        session(){
            if(!this.session && this.sendingFollowModerator)
                clearInterval(this.intervalID);
        }
    },
    methods:{
        ...mapActions(["sendCommand"]),
        ...mapMutations(["setSendingFollowModerator"]),
        toggleFollowModeratorMode(){
            this.setSendingFollowModerator(!this.sendingFollowModerator);

            // Disable Control for other Users
            this.sendCommand({type: "CommandChangeUserControl",data: {userControl: !this.sendingFollowModerator}});
            
            // Send Position every 10ms
            if(this.sendingFollowModerator){
                this.intervalID = setInterval(() => {
                    // TODO: 3D Viewer Synchronization
                    if(window.engine3DViewer.activeRenderLoops.length > 0){
                        let camera = window.scene3DViewer.activeCamera;
                        this.sendCommand({type: "CommandSendModeratorPosition", data: {type: "3DViewer", alpha: camera.alpha, beta: camera.beta, radius: camera.radius, target: camera.target}});
                    }else{
                        let camera = window.scene.activeCamera;
                        this.sendCommand({type: "CommandSendModeratorPosition", data: {type: "Default", alpha: camera.alpha, beta: camera.beta, fov: camera.fov, target: camera.target, currentSituationID: this.currentSituationID}});
                    }   
                }, 10);
            }else{
                clearInterval(this.intervalID);
            }
        },
        muteAll(){
            this.sendCommand({type: "CommandMute",data: {}});
        },
        stopVideoAll(){
            this.sendCommand({type: "CommandStopVideo",data: {}});
        },
        removeAll(){
            this.users.forEach(u => {
                if(u.id != this.localUserID){
                    let connection = this.openTokStreams.filter( x => x.connection.data.user_id == u.id )[0].connection;
                    this.session.forceDisconnect(connection);
                }
            });
        },
    }
}
</script>

<style scoped>
.ModeratorMenue{
    position: relative;
    position: absolute;
    background: white;
    filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.5));
    z-index: 10;
    padding: 0;
    width: 300px;
    left: calc(50% - 150px);
    bottom: 80px;
    max-height: 250px;
    overflow: hidden;
}
.mm-list-item-active{
    background: var(--primaryColor);
}
.mm-list-item-active .material-design-icon > .material-design-icon__svg{
    fill: white !important;
}
.material-design-icon {
	height: 25px;
	width: 25px;
}
.material-design-icon > .material-design-icon__svg {
    fill: rgb(61, 61, 61);
    height: 25px;
    width: 25px;
}
.mm-list-item-active .md-list-item-text{
    color: white;
}
.md-list-item-icon{
    margin-right: 10px;
}
.md-list-item-text{
    font-size: 14px;
}
</style>